import React from 'react';
import { history } from '../store/index';
import { store } from '../../NextApp';
import { generateQueryString } from "../../util/Api";

import {
  CREATE_COMPLAINT_SUCCESS,
  FETCH_COMPLAINT_SUCCESS,
  FETCH_UNSERVIECABLE_REPORT_SUCCESS,
  GET_COMPLAINT_SUCCESS,
  GET_OPEN_COUNT_START,
  GET_OPEN_COUNT_SUCCESS,
  GET_US_ASSET_COUNT_START,
  GET_US_ASSET_COUNT_SUCCESS,
  SAVE_COMPLAINT_QUERY,
  SAVE_COMPLAINT_REPORT_QUERY,
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import { fetchError, fetchFilter, fetchStart, fetchSuccess } from "./Common";
import { message, notification, Typography } from "antd";
import { arrayToCSV, downloadCSV } from "../../util/methods";
import moment from 'moment';
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";

const { Text, Title, Paragraph } = Typography;

export const getResourceSuccess = ({ data, count }) => {
  return {
    type: GET_COMPLAINT_SUCCESS,
    data,
    count
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_COMPLAINT_QUERY,
    query
  };
};

export const saveComplaintReportQuery = (query) => {
  return {
    type: SAVE_COMPLAINT_REPORT_QUERY,
    query,
  }
};

export const createResourceSuccess = ({ data }) => {
  return {
    type: CREATE_COMPLAINT_SUCCESS,
    data
  };
};

export const fetchResourceSuccess = ({ data }) => {
  return {
    type: FETCH_COMPLAINT_SUCCESS,
    data
  };
};

export const getUnserviceableReportSuccess = ({ data }) => {
  return {
    type: FETCH_UNSERVIECABLE_REPORT_SUCCESS,
    data,
  }
};


export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const { complaint } = store.getState();
      const { query } = complaint;
      const response = await axios.get(`/complaint?${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const { complaint } = store.getState();
      const { query } = complaint;
      const response = await axios.get(`/complaint/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns);
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};


export const getUnserviceableReport = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const { complaint } = store.getState();
      const { reportQuery } = complaint;
      const response = await axios.get(`/complaint/get-unserviceable-report?${generateQueryString(reportQuery)}`);
      dispatch(fetchSuccess());
      dispatch(getUnserviceableReportSuccess(response));
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};


/*export const createResource = (payload) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.post(`/complaint`, payload);
      dispatch(fetchSuccess());
      dispatch(createResourceSuccess({data: response.data}));
      history.push('/complaint');
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};*/

export const createResource = (payload, redirect = true, module) => {
  return async (dispatch) => {
    // console.log('payload', { ...payload });
    dispatch(fetchStart());
    try {

      let formData = new FormData();
      const documentData = [];
      let fileData = new FormData();
      payload.photos && payload.photos.map((item) => {
        // console.log('item photos', item); 
        fileData.append('files', item);
      });
      delete payload.photos;
      payload.documents && payload.documents.map((item, index) => {
        formData.append('files', item.file);
        let data = { ...item, fieldType: 'regular' };
        delete data.file;
        documentData.push(data)
      });

      payload.closingDocuments && payload.closingDocuments.map((item, index) => {
        formData.append('files', item.file);
        let data = { ...item, fieldType: 'closing' };
        delete data.file;
        documentData.push(data)
      });
      formData.append('documentData', JSON.stringify(documentData));


      payload.closingPhotos && payload.closingPhotos.map((item, index) => {
        // console.log('item', item);
        formData.append('files', item);
      });
      delete payload.closingPhotos;
      // }

      Object.keys(payload).forEach(key => {
        if (key === 'documents' || key === 'closingDocuments' || key === 'closingPhotos') {
          return
        }
        if (key === 'service') {
          formData.append(key, JSON.stringify(payload[key]));
          return;
        }
        if (payload[key] !== null) {
          formData.append(key, payload[key]);
        }
      });

      // console.log('formData', formData);
      const response = await axios.post(`/complaint`, formData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } });

      if (fileData.has('files') && response && response.data) {
        fileData.append('id', response.data._id);
        const kk = await axios.post('/complaint/upload-files-in-background', fileData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } })
      }

      dispatch(fetchSuccess());
      dispatch(createResourceSuccess({ data: response.data }));

      const { data: complaint } = response;
      if (complaint && complaint.jobCard) {
        const { jobCard, ...rest } = complaint;

        jobCard.complaint = rest;
        openNotification('success', jobCard, () => history.push('/job-card'));
      }

      if (!redirect) {
        dispatch(fetchFilter(module));
      } else {
        history.push('/complaint');
        dispatch(getResource());
      }
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};


export const updateResource = (payload, id, urlForBackJobCardReport) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      let formData = new FormData();
      const documentData = [];
      const documentIds = [];

      payload.documents && payload.documents.map((item, index) => {
        if (!item.file.path) {
          formData.append('files', item.file);
          let data = { ...item, fieldType: 'regular' };
          delete data.file;
          documentData.push(data)
        } else {
          documentIds.push({ id: item._id, fieldType: 'regular' });
        }
      });

      payload.closingDocuments && payload.closingDocuments.map((item, index) => {
        if (!item.file.path) {
          formData.append('files', item.file);
          let data = { ...item, fieldType: 'closing' };
          delete data.file;
          documentData.push(data)
        } else {
          documentIds.push({ id: item._id, fieldType: 'closing' });
        }
      });

      payload.closingPhotos && payload.closingPhotos.map((item, index) => {
        // console.log('item', item);
        formData.append('files', item);
      });
      delete payload.closingPhotos;

      formData.append('documentData', JSON.stringify(documentData));
      formData.append('documentIds', JSON.stringify(documentIds));
      // console.log(payload);
      let fileData = new FormData();
      payload.photos && payload.photos.map((item) => {
        fileData.append('files', item);
      });
      delete payload.photos;

      Object.keys(payload).forEach(key => {
        if (key === 'documents' || key === 'closingDocuments' || key === 'closingPhotos') {
          return
        }
        if (key === 'service') {
          formData.append(key, JSON.stringify(payload[key]));
          return;
        }
        if (payload[key] !== null) {
          formData.append(key, payload[key]);
        }
      });

      const response = await axios.put(`/complaint/${id}`, formData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } });
      // console.log('response', response, fileData);
      if (response && response.data && response.data.code && (response.data.code >= 400)) {
        message.error(response.data.message);
        return;
      }
      if (fileData.has('files') && response && response.data) {
        fileData.append('id', id);
        const kk = await axios.post('/complaint/upload-files-in-background', fileData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } })
      }
      dispatch(fetchSuccess());
      history.goBack();

      // if (urlForBackJobCardReport){
      //   history.push(urlForBackJobCardReport);
      // }else {
      //   dispatch(fetchSuccess());
      //   history.push('/complaint');
      //   dispatch(getResource());
      // }
      //   dispatch(fetchSuccess());
      //   history.goBack();
      //   //history.push('/complaint');
      //   dispatch(getResource());


    } catch (error) {
      console.log("Error****:", error);
      message.error(error.message);
      dispatch(fetchError(error.message));
    } finally {
      dispatch(fetchSuccess());
    }
  }
};

export const checkLastComplaint = (payload) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.post(`/complaint/checkLast`, payload);
      dispatch(fetchSuccess());
      return response.data;
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const fetchResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/complaint/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({ data: response.data }));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const checkCancelComplaint = (id) => {
  return async (dispatch) => {
    dispatch(fetchStart());

    try {
      const response = await axios.put(`/complaint/checkCancel/${id}`);
      dispatch(fetchSuccess());
      return response.data;
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const deleteResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.delete(`/complaint/${id}`);
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};


export const cancelComplaintResource = (id, record) => {
  const data = {
    record: record,
  };
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.put(`/complaint/cancelComplaint/${id}`, data);
      if (response && response.data && response.data.code && response.data.code === '201') {
        message.success(response.data.message);
      } else if (response && response.data && response.data.code && response.data.code === '404') {
        message.error(response.data.message);
      } else {
        message.error('An Error Occurred');
      }
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getUnserviceableAssetCount = (payload = {}) => {
  return async dispatch => {
    dispatch(getUSAssetCountStart());
    try {
      const response = await axios.post(`/complaint/get-unserviceable-asset-count`, payload);
      const promises = processUnserviceableAssets(response.data);
      Promise.all(promises).then(data => {

        dispatch(getUSAssetCountOk({
          count: data ? data.length : 0,
          activeCount: data.filter(d => d.assetSubLocation && d.assetSubLocation.vendor).length,
          leaseCount: data.filter(d => d.contract_id !== '').length,
          data
        }));
      })

    } catch (error) {
      dispatch(getUSAssetCountOk({ count: 0, activeCount: 0, leaseCount: 0, data: [] }));
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  };
};

const processUnserviceableAssets = (data) => {
  return data.map(async doc => {
    const complaint = doc && doc.comp && doc.comp.length && doc.comp[0] || { contract: [] };

    /**
     * Jay
     * Use this for lease count
     */
    /*let contract = complaint.contract.map(con => {
      if(con && con.assets && con.assets.periodTo) {
        if(moment(con.assets.periodTo).isSameOrAfter(moment())) {
          return con._id && con._id.id;
        }
      }
    }).filter(c => c).toString();*/

    return {
      asset: complaint.asset && complaint.asset.assetCode,
      assetSubLocation: complaint.asset && complaint.asset.client,
      complaint_date: complaint.complaintDate && moment(complaint.complaintDate).format('DD-MM-YYYY'),
      complaint_no: complaint.complaintNo,
      complaint_details: complaint.detailsOfComplaint,
      complaint_cause: complaint.causeOfDamage,
      job_card_no: complaint.jobCard && complaint.jobCard.jobCardNo,
      job_card_present_status: complaint.jobCardStatusObject && complaint.jobCardStatusObject.name,
      job_card_present_status_remark: complaint.jobCardStatus && complaint.jobCardStatus.details,
      present_status_update_date: complaint.jobCardStatus && complaint.jobCardStatus.date && moment(complaint.jobCardStatus.date).format('DD-MM-YYYY'),
      present_status_review_date: complaint.jobCardStatus && complaint.jobCardStatus.reviewDate && moment(complaint.jobCardStatus.reviewDate).format('DD-MM-YYYY'),
      // contract_id: contract,
      asset_location: complaint.asset && complaint.asset.location && complaint.asset.location.name,
      asset_sub_location: complaint.asset && complaint.asset.client && complaint.asset.client.name,
      target_completion_date: complaint.jobCard && complaint.jobCard.expectedDateOfCompletion
        && moment(complaint.jobCard.expectedDateOfCompletion).format('DD-MM-YYYY'),
      complaint_open_since: complaint.complaintDate ? moment().diff(moment(complaint.complaintDate), 'days') : 0,
    }
  })

};

export const downloadUnserviceableAsset = () => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const { complaint } = store.getState();
      const { usAssetCountData } = complaint;
      if (usAssetCountData && usAssetCountData.length) {
        const newData = usAssetCountData.map(doc => {
          const { assetSubLocation, ...rest } = doc;
          return rest;
        });
        const fileType =
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';

        const ws = XLSX.utils.json_to_sheet(newData, { cellDates: true, dateNF: 'DD-MM-YYYY' });
        const wb = { Sheets: { report: ws }, SheetNames: ['report'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(
          data,
          `unserviceable-assets-${Date.now()}${fileExtension}`,
        );
      }
      dispatch(fetchSuccess());
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  };
};

export const getUSAssetCountOk = ({ count, activeCount, leaseCount, data }) => {
  // console.log({count, activeCount, leaseCount, data});
  return {
    type: GET_US_ASSET_COUNT_SUCCESS,
    count,
    activeCount,
    leaseCount,
    data
  };
};

export const getUSAssetCountStart = () => {
  return {
    type: GET_US_ASSET_COUNT_START
  };
};

export const getOpenCountWithJobs = (payload = {}) => {
  return async dispatch => {
    dispatch(getOpenCountStart());
    try {
      const response = await axios.post(`/complaint/get-open-count-with-jobs`, payload);
      let totalOpenComplaints = 0;
      let totalOpenComplaintsWithoutJobs = 0;
      if (response.data) {
        const withJobsData = response.data.filter(doc => doc._id === true);
        const withoutJobsData = response.data.filter(doc => doc._id === false);

        if (withJobsData && withJobsData.length > 0) {
          totalOpenComplaints = parseInt(withJobsData[0]['count']);
        }
        if (withoutJobsData && withoutJobsData.length > 0) {
          totalOpenComplaintsWithoutJobs = parseInt(withoutJobsData[0]['count']);
          totalOpenComplaints += totalOpenComplaintsWithoutJobs;
        }
        dispatch(getOpenCountOk({
          openCount: totalOpenComplaints,
          openWithoutJobCount: totalOpenComplaintsWithoutJobs
        }));
      } else {
        dispatch(getOpenCountOk({
          openCount: 0,
          openWithoutJobCount: 0
        }));
      }
    } catch (error) {
      dispatch(getOpenCountOk({ count: 0 }));
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  };
};

export const getOpenCountOk = ({ openCount, openWithoutJobCount }) => {
  return {
    type: GET_OPEN_COUNT_SUCCESS,
    openCount,
    openWithoutJobCount
  };
};

export const getOpenCountStart = () => {
  return {
    type: GET_OPEN_COUNT_START
  };
};

const openNotification = (alertType, jobCard, callback) => {
  new Promise((resolve, _) => {
    const complaint = (jobCard && jobCard.complaint || {});
    const asset = (complaint && complaint.asset || {});
    const jobCardNo = jobCard && jobCard.jobCardNo;
    const assetCode = asset && asset.assetCode;
    const ownerCode = asset && asset.ownerCode;
    const altName = asset && asset.altName;
    const assetLabel = [assetCode, altName, ownerCode].filter(Boolean).join(' / ');
    const assetType = asset && asset.equipmentSubType && asset.equipmentSubType.assetType && asset.equipmentSubType.assetType.name;
    const assetModel = asset && asset.assetModel && asset.assetModel.name;
    const location = complaint && complaint.location && complaint.location.name;
    const subLocation = complaint && complaint.client && complaint.client.name;
    const expectedDateOfCompletion = jobCard && jobCard.expectedDateOfCompletion && moment(jobCard.expectedDateOfCompletion).format('DD-MM-YYYY');
    const complaintNo = complaint && complaint.complaintNo;
    const complaintDate = complaint && complaint.complaintDate && moment(complaint.complaintDate).format('DD-MM-YYYY');
    const causeOfDamage = complaint && complaint.causeOfDamage;
    const complaintDetail = complaint && complaint.detailsOfComplaint;
    notification[alertType]({
      duration: 30,
      message: alertType === 'success' ? <><Title level={4}>Job Card {jobCard.jobCardNo} created
        successfully</Title></> : 'Notification',
      description: (<>
        <Paragraph copyable={{
          tooltips: ['Click to copy', 'Copied'],
          text: `*Job Card No. :* ${jobCardNo}\n*Asset :* ${assetLabel}\n*Asset Type :* ${assetType}\n*Model :* ${assetModel}\n*Location :* ${location}\n*Sub Location :* ${subLocation}\n*Expected Completion Date :* ${expectedDateOfCompletion}\n*Complaint No. :* ${complaintNo}\n*Complaint Date :* ${complaintDate}\n*Cause of Damage :* ${causeOfDamage}\n*Complaint Details :* ${complaintDetail}`
        }}>
          <Text strong>Job Card No. : </Text><Text>{jobCardNo}</Text><br />
          <Text strong>Asset : </Text><Text>{assetLabel}</Text><br />
          <Text strong>Asset Type : </Text><Text>{assetType}</Text><br />
          <Text strong>Model : </Text><Text>{assetModel}</Text><br />
          <Text strong>Location : </Text><Text>{location}</Text><br />
          <Text strong>Sub Location : </Text><Text>{subLocation}</Text><br />
          <Text strong>Expected Completion Date : </Text><Text>{expectedDateOfCompletion}</Text><br />
          <Text strong>Complaint No. : </Text><Text>{complaintNo}</Text><br />
          <Text strong>Complaint Date : </Text><Text>{complaintDate}</Text><br />
          <Text strong>Cause of Damage : </Text><Text>{causeOfDamage}</Text><br />
          <Text strong>Complaint Details : </Text><Text>{complaintDetail}</Text>
        </Paragraph>
      </>),
      style: {
        width: 700,
        marginLeft: 335 - 700,
      }
    });
    // console.log(`Resolved`);
    resolve();
  }
  ).then(callback);
};
